/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UserLanguage {
  NlNL = "nl_NL",
  EnUS = "en_US",
  Fr = "fr",
  De = "de",
  It = "it",
  ItCH = "it_CH",
  NlBE = "nl_BE",
  FrBE = "fr_BE",
  DeAT = "de_AT",
  DeCH = "de_CH",
  FrCH = "fr_CH",
}

export enum ServiceListType {
  MOBILITY = "MOBILITY",
  FBS = "FBS",
  GAAS = "GAAS",
  GASES_SHOP = "GASES_SHOP",
}

export interface UserEntityResponse {
  userId: string;
  userName: string;
  alias?: string;
  isActive: boolean;
  email: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  language?: UserLanguage;
  contact: {
    contactId: string;
    name: string;
  };
  userRole?: {
    name: string;
  };
}

/** structure for external errors. */
export interface Type {
  /** A short, human-readable summary of the problem type.  It SHOULD NOT change from occurrence to occurrence of the problem, except for purposes of localization (e.g., using proactive content negotiation; see [RFC7231], Section 3.4). */
  title: string;
  correlationId: string;
  /** A human-readable explanation specific to this occurrence of the problem. */
  detail: string;
  /**
   * A URI reference [RFC3986] that identifies the problem type.  This specification encourages that, when dereferenced, it provide human-readable documentation for the problem type (e.g., using HTML [W3C.REC-html5-20141028]).  When this member is not present, its value is assumed to be "about:blank"
   * @default "about:blank"
   */
  type: string;
  /**
   * @min 100
   * @max 599
   */
  status: number;
}

export interface UserUpdateRequest {
  language?: UserLanguage;
  firstName?: string;
  lastName?: string;
  salutation?: "Mr." | "Ms." | "Mx.";
  telephoneNumber?: string;
}

/** A record was created or updated successfully. The record is returned in the data property of the body. */
export interface RecordUpserted {
  correlationId: string;
  data: object;
  /**
   * @min 200
   * @max 299
   * @default 200
   */
  status: number;
}

export interface AccountListWithServiceRoleAssignmentsResponse {
  user: {
    userId: string;
    name: string;
    email: string;
  };
  contact: {
    contactId: string;
    name: string;
    email?: string;
  };
  /** @minItems 0 */
  accounts: {
    name: string;
    accountId: string;
    /** @default false */
    default: boolean;
    /** @minItems 0 */
    services: {
      serviceId: string;
      serviceExternalId: string;
      /** @minItems 0 */
      businessAreas?: any[];
      subscription: {
        subscriptionId: string;
        name: string;
        minimalAmountOfPallets?: number;
      };
      /** @minItems 0 */
      serviceRoles: {
        serviceRoleId: string;
        serviceRoleExternalId: string;
        assignment: {
          assignmentId: string;
          name: string;
        };
      }[];
    }[];
    customerType: string;
    ERPCustomerId?: string;
  }[];
}

export interface AccountEntityExpandResponse {
  /** @minItems 0 */
  partners?: Items[];
  user: {
    userId: string;
    name: string;
    email: string;
    language?: UserLanguage;
  };
  contactAddresses?: {
    partnerId: string;
    kind:
      | "INVOICE"
      | "DELIVERY_NOTE"
      | "SAFETY_DATA"
      | "PDF"
      | "BIS_UBL"
      | "FACTUREX"
      | "ZUGFERD_EXTENDED"
      | "ZUGFERD_COMFORT"
      | "XRECHNUNGCII_PEPPOL"
      | "XRECHNUNGCII_EMAIL"
      | "PAYMENT_REMINDER";
    email: string;
    name1: string;
    name2: string;
    peppolId?: string;
  }[];
  contact: {
    contactId: string;
    name: string;
    email?: string;
    language?: UserLanguage;
  };
  account: {
    name: string;
    accountId: string;
    /** @default false */
    default: boolean;
    /** @minItems 0 */
    services: {
      serviceId: string;
      serviceExternalId: string;
      /** @minItems 0 */
      businessAreas?: any[];
      subscription: {
        subscriptionId: string;
        name: string;
        minimalAmountOfPallets?: number;
      };
      /** @minItems 0 */
      serviceRoles: {
        serviceRoleId: string;
        serviceRoleExternalId: string;
        assignment: {
          assignmentId: string;
          name: string;
        };
      }[];
    }[];
    customerType: string;
    /** @minItems 0 */
    businessAreasSummary?: any[];
    /** @minItems 0 */
    webstores?: Items3[];
    isManaged: boolean;
    ERPCustomerId?: string;
  };
  addresses?: {
    openingHours?: Items5[];
    salesOrganizationId?: string;
    name1?: string;
    addressId?: string;
    /** @maxLength 500 */
    addressInfo3?: string;
    countryCode: string;
    recipient?: Type4;
    restrictions?: {
      vehicle?: boolean;
      forklift?: boolean;
    };
    company?: string;
    streetNumber: string;
    /** @maxLength 250 */
    addressInfo2?: string;
    default: boolean;
    city: string;
    street: string;
    postalCode: string;
    /** @maxLength 250 */
    addressInfo1?: string;
    kind: "SHIPPING" | "BILLING";
  }[];
}

export interface Type1 {
  recordTypeExternalId: "Support";
  origin?: string;
  category?: string;
  businessArea?: string;
  email?: string;
  subject: string;
  summary?: string;
  comment?: string;
  salesOrganizationId?: string;
  revocationReference?: string;
  serviceRoleExternalId?: string;
}

/** @example {"caseId":"001bh00000EIIeVAYY","caseNumber":"0004343","subject":"A subject","summary":"Summary","comment":"There was a reason for thi case","businessArea":"FBS","category":"support","revocationReference":"21343255634"} */
export interface RetrieveCaseResponse {
  caseId: string;
  caseNumber: string;
  subject: string;
  summary?: string;
  comment?: string;
  businessArea?: string;
  category?: string;
  revocationReference?: string;
}

export interface ProductValuationRequestType {
  productCode: string;
}

/** A record was created successfully. The record is returned in the data property of the body. */
export interface RecordCreated {
  correlationId: string;
  data: object;
  /**
   * @min 200
   * @max 299
   * @default 201
   */
  status: number;
}

export interface ProductComponentsTaskRequest {
  /** @minItems 1 */
  components: {
    componentGas: string;
    quantity: number;
    unitOfMeasure: string;
    analysisPrecision?: number;
  }[];
  residualGas: string;
  analytics: string;
  certificate: string;
  formOfDelivery: string;
  personalNote?: string;
}

export interface CustomerEmailUpdateRequest {
  email?: string;
  peppolId?: string;
  kind:
    | "INVOICE"
    | "DELIVERY_NOTE"
    | "SAFETY_DATA"
    | "PDF"
    | "BIS_UBL"
    | "BIS_UBL_MAIL"
    | "FACTUREX"
    | "ZUGFERD_EXTENDED"
    | "ZUGFERD_COMFORT"
    | "ZUGFERD_EXTENDED_WSC"
    | "ZUGFERD_COMFORT_WSC"
    | "XRECHNUNGCII_PEPPOL"
    | "XRECHNUNGCII_EMAIL"
    | "PAYMENT_REMINDER";
  name1?: string;
  name2?: string;
  language?: UserLanguage;
}

/** A record was updated successfully. The record is returned in the data property of the body. */
export interface RecordUpdated {
  correlationId: string;
  data: object;
  /**
   * @min 200
   * @max 299
   * @default 200
   */
  status: number;
}

export interface CampaignAddRequest {
  campaignExternalId: string;
}

export interface CampaignMemberResponse {
  campaignMemberId: string;
}

export interface FBSContainerListResponse {
  /** @minItems 0 */
  containers: Items6[];
}

export interface FBSContainerEntityResponse {
  deliveryBlock?: string;
  rangeFlag?: string;
  serviceFlatRate?: number;
  visibleB2BUnit?: string;
  /** @format date */
  latestFillDate?: string;
  equipmentStatus?: string;
  invoiceBlock?: string;
  address: {
    containerNumber?: string;
    street?: string;
    streetNumber?: string;
    postalCode?: string;
    city?: string;
    countryCode?: string;
  };
  customer?: {
    ERPCustomerId?: string;
    recipientOfGoods?: string;
    grouping?: string;
    internalCustomerZS?: string;
  };
  daysUntilDelivery?: number;
  meterNumber?: string;
  rent?: number;
  usageForecast?: {
    month: number;
    usage: number;
    range: number;
  }[];
  supplyMode?: string;
  shippingPoint?: string;
  priceListType?: string;
  currentFillLevelPercentage?: number;
  product: {
    name?: string;
    code?: string;
  };
  terminationScheme?: string;
  unloadingPoint?: string;
  orderUnit?: string;
  contractId: string;
  bioTariffs?: {
    name: string;
    price: {
      net: number;
      gross: number;
    };
  }[];
  contract: {
    type?: string;
    /** @format date */
    startDate?: string;
    /** @format date */
    endDate?: string;
    version?: string;
    internalContractId?: string;
  };
  deliveryBlockCustomerbySalesOrganization?: string;
  equipmentNumber?: string;
  serialNumber: string;
  paymentTerms?: string;
  assetType?: string;
  unitFactor?: string;
  price: {
    listType?: string;
    net?: number;
    currency?: string;
    gross?: number;
    tax?: number;
    last?: {
      net?: number;
    };
  };
  /** @format date */
  forecastedEmptyTankDate?: string;
  volume: {
    size?: number;
    unit?: string;
    maxSize?: number;
    maxUnit?: string;
  };
  deliveryBlockCustomer?: string;
  correspondingContractId?: string;
  aboveOrUnderGround?: string;
  openOrder?: boolean;
}

export interface FBSCockpitResponse {
  currentFillLevelPercentage: number;
  currentOrderPrice: string;
  currentOrderPriceVAT: string;
  lastOrderPrice?: string;
  /** @format date */
  forecastEmptyTankDate?: string;
  usageForecast?: {
    month: number;
    usage: number;
    range: number;
  }[];
}

export interface FBSDeductionAvailableResponse {
  currentPrice: number;
  minPrice: number;
  maxPrice: number;
  availableDates: string[];
}

export interface FBSDeductionRequest {
  currentPrice: number;
  /** @format date */
  date: string;
}

/** Action posted without generating a new record */
export interface ActionPostedWithoutNewRecord {
  correlationId: string;
  message: string;
  /**
   * @min 200
   * @max 299
   * @default 201
   */
  status: number;
}

export interface FBSContainerAssessmentResponse {
  containers: {
    contractId: string;
    /** @format date */
    forecastedEmptyTankDate?: string;
    /** @format date */
    latestFillDate?: string;
    currentFillLevelPercentage?: number;
    daysUntilDelivery?: number;
    rangeFlag?: string;
    openOrder?: boolean;
  }[];
}

export interface FBSOrderListResponse {
  total?: number;
  /** @minItems 0 */
  orders: {
    contractId: string;
    /** @format date */
    purchaseDate: string;
    reference?: string;
    status?: string;
    /** @minItems 1 */
    lineItems: {
      /** @format date */
      deliveryDate?: string;
      trackingLink?: string;
      deliveryCode?: string;
      container: {
        serialNumber: string;
        amount: number;
        salesUnit: string;
      };
      product?: {
        name?: string;
      };
      address?: {
        containerNumber?: string;
        postalCode?: string;
        city?: string;
        street?: string;
        countryCode?: string;
        streetNumber?: string;
      };
    }[];
  }[];
}

export interface FBSOrderRequest {
  containers: {
    salesUnit?: string;
    comment?: string;
    ecoSurchargeIndicator?: string;
    /** @format date */
    purchaseDate?: string;
    internalContractId?: string;
    address?: {
      countryCode?: string;
      number?: string;
      street?: string;
      streetNumber?: string;
      postalCode?: string;
      city?: string;
    };
    /** @format date */
    forecastDate?: string;
    customer?: {
      recipientOfGoods?: string;
    };
    equipmentType?: string;
    /** @format date */
    distance?: string;
    /** @format date */
    agreementAcceptanceDate?: string;
    email?: string;
    fixedQuantity?: boolean;
    amount?: number;
    product: {
      code: string;
    };
    terminationScheme?: string;
    unloadingPoint?: string;
    settlementPurposeIndicator?: string;
    contractId: string;
    equipmentNumber: string;
    serialNumber?: string;
    forecastRemainingContent?: number;
    price?: {
      listType?: string;
      group?: string;
      gross?: number;
    };
    SMS?: string;
    remainingContent?: number;
    mobileNumber?: string;
    /** @format date */
    soonestDeliveryDate?: string;
    phoneNumber?: string;
  }[];
  customer?: {
    recipientOfGoods?: string;
    salesOrganization?: string;
    distributionChannel?: string;
    branch?: string;
    name?: string;
    internalCustomerZS?: string;
  };
  discountCode?: string;
  purchaseOrderNumber?: string;
}

export interface FBSOrderResponse {
  orderId: string;
}

export interface FBSSimulateOrderRequest {
  containers: {
    notifyShipping?: string;
    salesUnit?: string;
    ecoSurchargeIndicator?: string;
    /** @format date */
    purchaseDate?: string;
    address?: {
      countryCode?: string;
      number?: string;
      street?: string;
      streetNumber?: string;
      postalCode?: string;
      city?: string;
    };
    internalContractId?: string;
    customer?: {
      recipientOfGoods?: string;
    };
    /** @format date */
    agreementAcceptanceDate?: string;
    product: {
      code: string;
    };
    amount?: number;
    fixedQuantity?: boolean;
    unloadingPoint?: string;
    terminationScheme?: string;
    contractId: string;
    incoterms?: string;
    price?: {
      listType?: string;
      group?: string;
      gross?: number;
    };
  }[];
  customer?: {
    recipientOfGoods?: string;
    salesOrganization?: string;
    distributionChannel?: string;
    branch?: string;
    name?: string;
    internalCustomerZS?: string;
  };
  discountCode?: string;
  purchaseOrderNumber?: string;
}

export interface FBSSimulateOrderResponse {
  price?: {
    gross: number;
    net: number;
    tax: number;
    discount?: number;
    currency: string;
  };
  containers: {
    contractId: string;
    position: string;
    product?: {
      code?: string;
    };
    price?: {
      base?: number;
      net?: number;
      gross?: number;
      tax?: number;
      per100Liter?: number;
      perLiter?: number;
      roadToll?: number;
      smallQuantitySurcharge?: number;
      unitsPerPrice?: number;
    };
    amount?: number;
    salesUnit?: string;
    rateUnit?: string;
    conditionUnit?: string;
    ecoSurchargeIndicator?: number;
    notifyShipping?: number;
    minimalQuantityCheck?: boolean;
  }[];
}

export interface FBSMBaseMeterReadingRequest {
  customer?: {
    salesOrganizationId?: string;
    distributionChannel?: string;
    branch?: string;
  };
  meterReading: {
    reason:
      | "METER_INSTALLATION"
      | "MOVE_IN"
      | "BILLING"
      | "PRICE_CHANGE"
      | "MOVE_OUT"
      | "OTHER"
      | "EXTRACTION"
      | "METER_REMOVAL"
      | "TAX_CHANGE";
    /** @format date-time */
    datetime?: string;
    /** @format date */
    date?: string;
    meterNumber?: string;
    contractNumber?: string;
    mode?: "PHONE" | "PORTAL";
    value: number;
    currentFillLevelPercentage?: number;
  };
  dataConfirmed?: boolean;
  /**
   * @min 1
   * @max 2
   */
  fileAmount?: number;
}

export interface OpportunityRequest {
  stageName?: string;
  isWon?: boolean;
  reason?: string;
  term?: {
    contract?: string;
    unit?: string;
  };
  name?: string;
  address?: {
    postalCode?: string;
    street?: string;
    city?: string;
  };
  /** @format date */
  closeDate?: string;
  customer?: {
    ERPCustomerId?: string;
    salesOrganizationId?: string;
  };
  /** @format date */
  phaseClosedWonDate?: string;
  currentEnergyType?: string;
  productHierarchyLevel2?: string;
  supplyMode?: string;
  primaryContact?: string;
  unit?: string;
  recordTypeExternalId?: string;
  basicDetails?: string;
  contractId?: string;
  contract?: {
    /** @format date */
    startDate?: string;
  };
  serialNumber?: string;
  price?: {
    listType?: string;
  };
  productHierarchyLevel1?: string;
  volume?: {
    size?: number;
  };
  description?: string;
  adjustment?: boolean;
  campaignExternalId?: string;
  /** @format date */
  createdDate?: string;
}

export interface OpportunitiesResponse {
  /** @minItems 0 */
  opportunities: Items7[];
}

export interface FBSInvoicesResponse {
  invoices: {
    number: string;
    /** @format date */
    date: string;
    amount: number;
  }[];
}

export interface GASAddShippingAddressRequest {
  openingHours?: Items5[];
  salesOrganizationId?: string;
  name1?: string;
  addressId?: string;
  /** @maxLength 500 */
  addressInfo3?: string;
  countryCode: string;
  recipient?: Type4;
  restrictions?: {
    vehicle?: boolean;
    forklift?: boolean;
  };
  company?: string;
  streetNumber: string;
  /** @maxLength 250 */
  addressInfo2?: string;
  default: boolean;
  city: string;
  street: string;
  postalCode: string;
  /** @maxLength 250 */
  addressInfo1?: string;
}

export interface GASAddShippingAddressResponse {
  addressId: string;
}

export interface GASOrderHistoryResponse {
  total?: number;
  /** @minItems 0 */
  orders: {
    /** @format date */
    purchaseDate: string;
    /** @format date */
    deliveryDate?: string;
    purchaserName: string;
    processingStatus?: string;
    vehicleNumber?: string;
    statusCode: string;
    orderNumber: string;
    /** @format date */
    requestedDeliveryDate: string;
    contractId: string;
    /** @minItems 0 */
    addresses?: {
      openingHours?: Items5[];
      salesOrganizationId?: string;
      name1?: string;
      addressId: string;
      /** @maxLength 500 */
      addressInfo3?: string;
      countryCode: string;
      recipient?: Type4;
      restrictions?: {
        vehicle?: boolean;
        forklift?: boolean;
      };
      company?: string;
      selected: boolean;
      streetNumber: string;
      /** @maxLength 250 */
      addressInfo2?: string;
      default: boolean;
      city: string;
      street: string;
      postalCode: string;
      /** @maxLength 250 */
      addressInfo1?: string;
      kind: "SHIPPING";
    }[];
    status: string;
  }[];
}

export interface GASOrderDetailsResponse {
  /** @format date */
  purchaseDate: string;
  /** @format date */
  deliveryDate?: string;
  address: {
    openingHours?: Items5[];
    salesOrganizationId?: string;
    name1?: string;
    addressId: string;
    /** @maxLength 500 */
    addressInfo3?: string;
    countryCode: string;
    recipient?: Type4;
    restrictions?: {
      vehicle?: boolean;
      forklift?: boolean;
    };
    company?: string;
    streetNumber: string;
    /** @maxLength 250 */
    addressInfo2?: string;
    default: boolean;
    city: string;
    street: string;
    postalCode: string;
    /** @maxLength 250 */
    addressInfo1?: string;
    kind: "SHIPPING";
  };
  purchaserName: string;
  deliveries?: {
    deliveryId: string;
    invoiceId: string;
    deliveryNoteURL?: string;
    deliveryReceiptURL?: string;
    invoiceURL?: string;
    /** @minItems 0 */
    lineItems: Type8[];
  }[];
  statusCode: string;
  orderNumber: string;
  /** @format date */
  requestedDeliveryDate: string;
  contractId: string;
  /** @minItems 0 */
  pendingItems?: Type8[];
  status: string;
}

export interface SearchResponseType {
  /** @minItems 0 */
  assets: {
    /** Identifier of the entity we are aiming to search a linked asset/document. This can be an invoice id, container id, etc... */
    id?: string;
    /** Identifier of an asset in the final storage system. This can be a doxis document Id, a Azure blob id or similar */
    assetId?: string;
    /** Container or Path where the asset is located. */
    locationReference?: string;
    /** The language code bound to the document */
    language?: string;
    /** The document number */
    documentNumber?: string;
    /** The barcode number */
    barcodeNumber?: string;
    /** The SAP customer number */
    ERPCustomerId?: string;
    /** The type of the document */
    documentType?: string;
    /**
     * The date of the document
     * @format date
     */
    documentDate?: string;
    /** The doxis uuid of the document */
    documentId?: string;
  }[];
}

export interface SearchAssetsRequestType {
  ERPCustomerId?: string;
  /** @minItems 1 */
  assets: {
    id: string;
    salesOrganizationId?: string;
    barcodeNumber?: string;
    /** @format date */
    startDate?: string;
    /** @format date */
    endDate?: string;
    services?: ServiceListType[];
  }[];
}

export interface DownloadResponseSignedUrlsType {
  /** @minItems 0 */
  assets: any[];
}

export interface UploadRequestSignedURLsType {
  /** @minItems 0 */
  assets: {
    /** @minItems 1 */
    attributes: {
      key: string;
      value: string;
    }[];
  }[];
}

export interface UploadResponseSignedUrlsType {
  /** @minItems 1 */
  assets: any[];
}

export interface SearchCartsResponseType {
  /** @minItems 0 */
  carts: Items9[];
}

export type CreateCartRequestType = object;

export interface CreateCartResponseType {
  cartId: string;
  accountId: string;
}

export interface RetrieveCartResponseType {
  uniqueProductCount: number;
  name: string;
  currencyISO: string;
  cartId: string;
  accountId: string;
  purchaseOrderNumber?: string;
  totalProductCount: number;
  ownerId: string;
  status:
    | "PROCESSING"
    | "ACTIVE"
    | "CLOSED"
    | "PENDING_DELETE"
    | "PENDING_CLOSED";
  webstoreExternalId: string;
}

export interface UpdateCartRequestType {
  status:
    | "ACTIVE"
    | "CHECKOUT"
    | "CLOSED"
    | "PROCESSING"
    | "PENDING_DELETE"
    | "PENDING_CLOSED";
  contactId?: string;
  userEmail?: string;
  ERPCustomerId?: string;
}

export interface RetrieveCartItemsResponseType {
  cartId: string;
  accountId: string;
  /** @minItems 0 */
  items: {
    cartItemId: string;
    productId: string;
    externalId: string;
    externalParentId?: string;
    quantity: number;
    name?: string;
    imageURL?: string;
  }[];
}

export interface AddCartItemRequestType {
  productId: string;
  itemType: "PRODUCT";
  quantity: number;
}

export interface UpsertCartItemResponseType {
  accountId: string;
  cartId: string;
  productId: string;
  cartItemId?: string;
  quantity: number;
}

export interface UpdateCartItemRequestType {
  quantity: number;
}

export interface GASOrderRequest {
  purchaseNumber?: string;
  origin?: string;
  customer?: {
    recipientOfGoods?: string;
    salesOrganization?: string;
    distributionChannel?: string;
    branch?: string;
    name?: string;
    contactId?: string;
    userEmail?: string;
    ERPCustomerId?: string;
  };
  vehicleNumber?: string;
  /** @format date */
  requestedDeliveryDate?: string;
  shippingPoint?: string;
  text?: string;
  note?: string;
  deliveryMode?: "PICKUP" | "DISPATCH";
  requestedDeliveryDateType?: "DESIRED_DATE" | "GIVEN_DATE";
  phoneNumber?: string;
}

export interface GASOrderResponse {
  /** @minItems 1 */
  orders: {
    id: string;
  }[];
}

export interface GASCheckoutSimulationRequest {
  purchaseNumber?: string;
  origin?: string;
  customer?: {
    recipientOfGoods?: string;
    salesOrganization?: string;
    distributionChannel?: string;
    branch?: string;
    name?: string;
    contactId?: string;
    userEmail?: string;
    ERPCustomerId?: string;
  };
  vehicleNumber?: string;
  /** @format date */
  requestedDeliveryDate?: string;
  shippingPoint?: string;
  text?: string;
  note?: string;
  deliveryMode?: "PICKUP" | "DISPATCH";
  requestedDeliveryDateType?: "DESIRED_DATE" | "GIVEN_DATE";
  phoneNumber?: string;
}

export interface GASCheckoutSimulationResponse {
  purchaseNumber?: string;
  /** @format date */
  priceDate?: string;
  origin?: string;
  /** @minItems 1 */
  lineItems: {
    pricePerUnit?: number;
    amount: number;
    product: {
      code: string;
    };
    currency?: string;
    price: number;
  }[];
  /** @format date */
  purchaseDate?: string;
  additionalCosts: {
    total: number;
    entries: {
      text: string;
      price: number;
      currency: string;
    }[];
  };
  /** @format date */
  earliestDeliveryDate?: string;
  customer?: {
    recipientOfGoods?: string;
    salesOrganization?: string;
    distributionChannel?: string;
    branch?: string;
    name?: string;
    contactId?: string;
    userEmail?: string;
    ERPCustomerId?: string;
  };
  vehicleNumber?: string;
  /** @format date */
  nextDeliveryDate?: string;
  /** @format date */
  requestedDeliveryDate?: string;
  shippingPoint?: string;
  text?: string;
  price: {
    gross: number;
    net: number;
    tax: number;
    currency: string;
  };
  note?: string;
  deliveryMode?: "PICKUP" | "DISPATCH";
  requestedDeliveryDateType?: "DESIRED_DATE" | "GIVEN_DATE";
  phoneNumber?: string;
}

export interface SearchWishlistsResponseType {
  /** @minItems 0 */
  wishlists: Items10[];
}

export type CreateWishlistRequestType = object;

export interface CreateWishlistResponseType {
  accountId: string;
  wishlistId: string;
}

export interface RetrieveWishlistResponseType {
  name: string;
  accountId: string;
  productCount?: number;
  ownerId: string;
  webstoreExternalId: string;
  wishlistId: string;
}

export interface RetrieveWishlistItemsResponseType {
  accountId: string;
  /** @minItems 0 */
  items: {
    wishlistItemId: string;
    productId: string;
    externalId: string;
    externalParentId?: string;
    name?: string;
    imageURL?: string;
    description?: string;
  }[];
  wishlistId: string;
}

export interface AddWishlistItemRequestType {
  productId: string;
  description?: string;
}

export interface UpsertWishlistItemResponseType {
  accountId: string;
  wishlistId: string;
  productId: string;
  description?: string;
  wishlistItemId?: string;
}

export interface UpdateWishlistItemRequestType {
  description: string;
}

export interface MPCProductResponseType {
  /** @minItems 0 */
  products: Items11[];
}

/** structure for external errors. */
export interface Type2 {
  errors?: object[];
  /** A short, human-readable summary of the problem type.  It SHOULD NOT change from occurrence to occurrence of the problem, except for purposes of localization (e.g., using proactive content negotiation; see [RFC7231], Section 3.4). */
  title: string;
  correlationId: string;
  /** A human-readable explanation specific to this occurrence of the problem. */
  detail: string;
  /**
   * A URI reference [RFC3986] that identifies the problem type.  This specification encourages that, when dereferenced, it provide human-readable documentation for the problem type (e.g., using HTML [W3C.REC-html5-20141028]).  When this member is not present, its value is assumed to be "about:blank"
   * @default "about:blank"
   */
  type: string;
  /**
   * @min 100
   * @max 599
   */
  status: number;
}

export interface ProductRecommendationsResponseType {
  total: number;
  /** @minItems 0 */
  products: Items12[];
}

export interface ProductPricesResponsetype {
  prices: Items13[];
}

export interface RentalsSearchResponse {
  /** @minItems 0 */
  rentals: {
    group: string;
    total: number;
    /** @minItems 0 */
    lineItems: {
      customer?: {
        ERPCustomerId: string;
        salesOrganizationId: string;
        name1?: string;
        name2?: string;
      };
      contractId?: string;
      name1?: string;
      name2?: string;
      materialGroup4?: string;
      group?: string;
      barCode?: string;
      batchNumber?: string;
      stock?: number;
      unit?: string;
      charge?: string;
      orderNumber?: string;
      /** @format date */
      receiptDate?: string;
      /** @format date */
      postingDate?: string;
      period?: string;
      /** @format date */
      dueDate?: string;
      address: {
        city?: string;
        street?: string;
        postalCode?: string;
        countryCode?: string;
      };
      fill: {
        productCode?: string;
        name?: string;
      };
      translations?: {
        language: string;
        name: string;
      }[];
    }[];
  }[];
}

export interface QuotasResponse {
  /** @minItems 0 */
  quotas: {
    productCode?: string;
    description?: string;
    deliveredUnits?: number;
    deliveredKG?: number;
    equivalentCO2?: number;
    equivalentCO2KG?: number;
    gross?: number;
  }[];
}

export interface PickupsResponse {
  /** @minItems 0 */
  addresses: {
    kind: "BILLING";
    name1?: string;
    name2?: string;
    addressId?: string;
    salesOrganizationId?: string;
    street?: string;
    countryCode?: string;
    city?: string;
    postalCode?: string;
  }[];
}

export interface DocumentValidationsRequest {
  ERPCustomerId: string;
  channel: "FBS" | "GAS";
  referenceNumber?: string;
}

/** @example {"salesOrganization":"0005"} */
export interface DocumentValidationsResponse {
  salesOrganization: string;
}

export interface ProductSearchResponseType {
  /** @minItems 0 */
  products: Items14[];
}

export interface CatalogueProductDetailsType {
  productId: string;
  externalId: string;
  productCode: string;
  productClass?: string;
  name?: string;
  customName?: string;
  description?: string;
  /** @minItems 0 */
  imageURLs?: Items16[];
  previewText?: string;
  summary?: string;
  importantInformation?: string;
  typicalApplication?: string;
  fillingConditions?: string;
  properties?: string;
  bottleShoulderColor?: string;
  state?: string;
  purity?: number;
  typicalApplications?: string;
  refrigerantDivisions?: string;
  norm?: string;
  normAdditions?: string;
  isVisible?: boolean;
  isBuyable?: boolean;
  gasTypeHardware?: string;
  material?: string;
  controlRange?: string;
  connection?: string;
  output?: string;
  certificate?: string;
  container?: string;
  mixtureType?: string;
  bottleType?: string;
  fillingSeason?: string;
  volume?: number;
  manufacturingPrecision?: number;
  stability?: number;
  fillingConnection?: string;
  valveMaterial?: string;
  fillingPressure?: string;
  fillingCapacity?: number;
  valvePrimary?: string;
  valveSecondary?: string;
  inGGStock?: boolean;
  categories?: Items17[];
  translations?: Items18[];
  /** @minItems 0 */
  characteristics: Items19[];
  /** @minItems 0 */
  components?: Items20[];
  residualGas?: Items15;
  /** @minItems 0 */
  variants?: {
    productId: string;
    externalId?: string;
    productCode?: string;
    productClass?: string;
    customName?: string;
    /** @minItems 0 */
    imageURLs?: Items16[];
    bottleType?: string;
    bottleCharacteristics?: string;
    fillingPressure?: string;
    fillingCapacity?: number;
    fillingCapacityUoM?: string;
    valvePrimary?: string;
    valveSecondary?: string;
    volume?: number;
    isBuyable?: boolean;
    isVisible?: boolean;
    isPreferred?: boolean;
    gasTypeHardware?: string;
    material?: string;
    controlRange?: string;
    connection?: string;
    output?: string;
    EClassVersion?: string;
    EClassCategoryId?: string;
    amountPallet?: number;
    translations?: Items18[];
  }[];
}

export interface DownloadRequestSignedURLsType {
  /**
   * Epoch timestamp in milliseconds. Default expiration time is 1 hour.
   * @min 0
   * @example 1720441200000
   */
  expiry?: number;
  /** @minItems 1 */
  assets: {
    assetId: string;
    locationReference: string;
  }[];
}

export interface PickListResponse {
  /** @minItems 0 */
  fields: FieldType[];
}

export interface BarcodeProductType {
  barcode: string;
  productCode: string;
  plant: string;
}

export interface Items {
  name?: string;
  department?: string;
  telephone?: string;
  mail?: string;
  fax?: string;
  title?: string;
  salesOrganizationId?: string;
  distributionChannel?: string;
  branch?: string;
}

export interface Items3 {
  webstoreId: string;
  webstoreExternalId: string;
  name: string;
  salesOrganizationId: string;
}

export interface Type4 {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export interface Items5 {
  dayOfWeek:
    | "MONDAY"
    | "TUESDAY"
    | "WEDNESDAY"
    | "THURSDAY"
    | "FRIDAY"
    | "SATURDAY"
    | "SUNDAY";
  dayTime: "MORNING" | "AFTERNOON";
  /** @format time */
  startTime: string;
  /** @format time */
  endTime: string;
}

export interface Items6 {
  deliveryBlock?: string;
  rangeFlag?: string;
  serviceFlatRate?: number;
  visibleB2BUnit?: string;
  /** @format date */
  latestFillDate?: string;
  equipmentStatus?: string;
  invoiceBlock?: string;
  address: {
    containerNumber?: string;
    street?: string;
    streetNumber?: string;
    postalCode?: string;
    city?: string;
    countryCode?: string;
  };
  customer?: {
    ERPCustomerId?: string;
    recipientOfGoods?: string;
    grouping?: string;
    internalCustomerZS?: string;
  };
  daysUntilDelivery?: number;
  meterNumber?: string;
  rent?: number;
  usageForecast?: {
    month: number;
    usage: number;
    range: number;
  }[];
  supplyMode?: string;
  shippingPoint?: string;
  priceListType?: string;
  currentFillLevelPercentage?: number;
  product: {
    name?: string;
    code?: string;
  };
  terminationScheme?: string;
  unloadingPoint?: string;
  orderUnit?: string;
  contractId: string;
  bioTariffs?: {
    name: string;
    price: {
      net: number;
      gross: number;
    };
  }[];
  contract: {
    type?: string;
    /** @format date */
    startDate?: string;
    /** @format date */
    endDate?: string;
    version?: string;
    internalContractId?: string;
  };
  deliveryBlockCustomerbySalesOrganization?: string;
  equipmentNumber?: string;
  serialNumber: string;
  paymentTerms?: string;
  assetType?: string;
  unitFactor?: string;
  price: {
    listType?: string;
    net?: number;
    currency?: string;
    gross?: number;
    tax?: number;
    last?: {
      net?: number;
    };
  };
  /** @format date */
  forecastedEmptyTankDate?: string;
  volume: {
    size?: number;
    unit?: string;
    maxSize?: number;
    maxUnit?: string;
  };
  deliveryBlockCustomer?: string;
  correspondingContractId?: string;
  aboveOrUnderGround?: string;
  openOrder?: boolean;
}

export interface Items7 {
  stageName?: string;
  isWon?: boolean;
  reason?: string;
  term?: {
    contract?: string;
    unit?: string;
  };
  name?: string;
  address?: {
    postalCode?: string;
    street?: string;
    city?: string;
  };
  /** @format date */
  closeDate?: string;
  customer?: {
    ERPCustomerId?: string;
    salesOrganizationId?: string;
  };
  /** @format date */
  phaseClosedWonDate?: string;
  currentEnergyType?: string;
  productHierarchyLevel2?: string;
  supplyMode?: string;
  primaryContact?: string;
  unit?: string;
  recordTypeExternalId?: string;
  basicDetails?: string;
  contractId?: string;
  contract?: {
    /** @format date */
    startDate?: string;
  };
  serialNumber?: string;
  opportunityId: string;
  price?: {
    listType?: string;
  };
  productHierarchyLevel1?: string;
  volume?: {
    size?: number;
  };
  description?: string;
  adjustment?: boolean;
  campaignExternalId?: string;
  /** @format date */
  createdDate?: string;
}

export interface Type8 {
  position: string;
  positionType: string;
  productCode: string;
  description?: string;
  quantity: number;
}

export interface SignedUrlSuccess {
  id?: string;
  assetId: string;
  locationReference: string;
  signedUrl: string;
  documentId?: string;
}

export interface SignedUrlError {
  assetId: string;
  error: string;
  documentId?: string;
}

export interface UploadSignedUrlSuccess {
  locationReference: string;
  signedUrl: string;
}

export interface UploadSignedUrlError {
  error: string;
}

export interface Items9 {
  uniqueProductCount: number;
  name: string;
  currencyISO: string;
  cartId: string;
  accountId: string;
  purchaseOrderNumber?: string;
  totalProductCount: number;
  ownerId: string;
  status:
    | "PROCESSING"
    | "ACTIVE"
    | "CLOSED"
    | "PENDING_DELETE"
    | "PENDING_CLOSED";
  webstoreExternalId: string;
}

export interface Items10 {
  name: string;
  accountId: string;
  productCount?: number;
  ownerId: string;
  webstoreExternalId: string;
  wishlistId: string;
}

export interface Items11 {
  productId: string;
  externalId: string;
  name?: string;
  categories?: Items17[];
  /** @minItems 0 */
  variants?: {
    productId: string;
    externalId: string;
    name?: string;
    bottleType?: string;
    fillingCapacity?: number;
    unitOfSales?: string;
    isBuyable?: boolean;
    isVisible?: boolean;
    isPreferred?: boolean;
  }[];
}

export interface Items12 {
  EClassVersion?: string;
  isPreferred?: boolean;
  /** @minItems 0 */
  imageURLs?: Items16[];
  externalId: string;
  name?: string;
  externalParentId?: string;
  isBuyable?: boolean;
  /** @minItems 0 */
  translations: {
    language: string;
    customName?: string;
    description?: string;
    previewText?: string;
  }[];
  productId: string;
  productClass: string;
  isVisible?: boolean;
  EClassCategoryId?: string;
  family?: string;
  currency?: string;
  previewText?: string;
  price?: number;
  description?: string;
}

export interface Items13 {
  externalId: string;
  price: number;
  currency: string;
}

export interface Items14 {
  productId: string;
  externalId: string;
  productClass: string;
  externalParentId?: string;
  name?: string;
  family?: string;
  /** @minItems 0 */
  imageURLs?: Items16[];
  description?: string;
  isBuyable?: boolean;
  isVisible?: boolean;
  isPreferred?: boolean;
  EClassVersion?: string;
  EClassCategoryId?: string;
  previewText?: string;
  /** @minItems 0 */
  translations: {
    language: string;
    customName?: string;
    description?: string;
    previewText?: string;
  }[];
}

export interface Items15 {
  externalId: string;
  name?: string;
  CASNumber?: string;
}

export interface Items16 {
  imageURL: string;
  isPrimary?: boolean;
}

export interface Items17 {
  categoryId?: string;
  externalId?: string;
  parentCategoryId?: string;
  categoryName?: string;
  isMPCProduct?: boolean;
  translations?: Items18[];
}

export interface Items18 {
  language?: string;
  name?: string;
  customName?: string;
  description?: string;
  typicalApplication?: string;
  previewText?: string;
  summary?: string;
  importantInformation?: string;
  alternativePhysicalDataFreeText?: string;
  additionalComponentInformation?: string;
}

export interface Items19 {
  value: string;
  characteristic: string;
  type: string;
  name: string;
  externalId: string;
}

export interface Items20 {
  type?: string;
  componentGas?: string;
  quantity?: number;
  unitOfMeasure?: string;
  analysisPrecision?: number;
}

export interface FieldType {
  name: string;
  values?: {
    label: string;
    value: string;
    fields?: FieldType[];
  }[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title wag-exp-hub-api
 * @version v1
 * @externalDocs http://
 *
 * The HUB API serves as a unified gateway that consolidates all essential functionalities required by the One platform.
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  users = {
    /**
     * @description Retrieve user data.
     *
     * @name RetrieveUserData
     * @request GET:/users/{userId}
     * @secure
     */
    retrieveUserData: (userId: string, params: RequestParams = {}) =>
      this.request<UserEntityResponse, Type | void>({
        path: `/users/${userId}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update User data.
     *
     * @name UpdateUserData
     * @request PATCH:/users/{userId}
     * @secure
     */
    updateUserData: (
      userId: string,
      generated: UserUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<RecordUpserted, Type | void>({
        path: `/users/${userId}`,
        method: "PATCH",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers
     * @request OPTIONS:/users/{userId}
     * @secure
     */
    optionsUsers: (userId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/users/${userId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve a list of accounts with existing Service Role Assigments.
     *
     * @name RetrieveAListOfAccountsWithExistingServiceRoleAssigments
     * @request GET:/users/{userId}/accounts
     * @secure
     */
    retrieveAListOfAccountsWithExistingServiceRoleAssigments: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<AccountListWithServiceRoleAssignmentsResponse, Type | void>({
        path: `/users/${userId}/accounts`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers2
     * @request OPTIONS:/users/{userId}/accounts
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers2: (userId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve account data
     *
     * @name RetrieveAccountData
     * @request GET:/users/{userId}/accounts/{accountId}
     * @secure
     */
    retrieveAccountData: (
      accountId: string,
      userId: string,
      query?: {
        /** @pattern ^([a-zA-Z0-9_]+)(,[a-zA-Z0-9_]+)*$ */
        expand?: string;
        /**
         * addresses functions  related to PARVW
         * @pattern ^([a-zA-Z0-9_]+)(,[a-zA-Z0-9_]+)*$
         */
        addressesKind?: string;
        /**
         * Contact functions related to PAFKT
         * @pattern ^([a-zA-Z0-9_]+)(,[a-zA-Z0-9_]+)*$
         */
        contactAddressesKind?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AccountEntityExpandResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers3
     * @request OPTIONS:/users/{userId}/accounts/{accountId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers3: (
      accountId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Create a new case
     *
     * @name CreateANewCase
     * @request POST:/users/{userId}/accounts/{accountId}/cases
     * @secure
     */
    createANewCase: (
      userId: string,
      accountId: string,
      generated: Type1,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveCaseResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/cases`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers4
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/cases
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers4: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/cases`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Create a Product valuation
     *
     * @name CreateAProductValuation
     * @request POST:/users/{userId}/accounts/{accountId}/products/components/valuations
     * @secure
     */
    createAProductValuation: (
      userId: string,
      accountId: string,
      generated: ProductValuationRequestType,
      params: RequestParams = {},
    ) =>
      this.request<RecordCreated, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/products/components/valuations`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers5
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/products/components/valuations
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers5: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/products/components/valuations`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Create a Product Component related Task
     *
     * @name CreateAProductComponentRelatedTask
     * @request POST:/users/{userId}/accounts/{accountId}/products/components/{componentCategory}/tasks
     * @secure
     */
    createAProductComponentRelatedTask: (
      userId: string,
      accountId: string,
      componentCategory: "gas-mixtures",
      generated: ProductComponentsTaskRequest,
      params: RequestParams = {},
    ) =>
      this.request<RecordCreated, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/products/components/${componentCategory}/tasks`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers6
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/products/components/{componentCategory}/tasks
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers6: (
      userId: string,
      accountId: string,
      componentCategory: "gas-mixtures",
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/products/components/${componentCategory}/tasks`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update customer email
     *
     * @name UpdateCustomerEmail
     * @request PATCH:/users/{userId}/accounts/{accountId}/emails
     * @secure
     */
    updateCustomerEmail: (
      userId: string,
      accountId: string,
      generated: CustomerEmailUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<RecordUpdated, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/emails`,
        method: "PATCH",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers7
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/emails
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers7: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/emails`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete an email address
     *
     * @name DeleteAnEmailAddress
     * @request DELETE:/users/{userId}/accounts/{accountId}/emails/{partnerId}
     * @secure
     */
    deleteAnEmailAddress: (
      partnerId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/emails/${partnerId}`,
        method: "DELETE",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers8
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/emails/{partnerId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers8: (
      partnerId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/emails/${partnerId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Add a member to a campaign
     *
     * @name AddAMemberToACampaign
     * @request POST:/users/{userId}/accounts/{accountId}/campaigns
     * @secure
     */
    addAMemberToACampaign: (
      userId: string,
      accountId: string,
      generated: CampaignAddRequest,
      params: RequestParams = {},
    ) =>
      this.request<CampaignMemberResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/campaigns`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers9
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/campaigns
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers9: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/campaigns`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve the campaign member id
     *
     * @name RetrieveTheCampaignMemberId
     * @request GET:/users/{userId}/accounts/{accountId}/campaigns/{campaignExternalId}
     * @secure
     */
    retrieveTheCampaignMemberId: (
      campaignExternalId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignMemberResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/campaigns/${campaignExternalId}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers10
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/campaigns/{campaignExternalId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers10: (
      campaignExternalId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/campaigns/${campaignExternalId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete an association between user and account
     *
     * @name DeleteAnAssociationBetweenUserAndAccount
     * @request DELETE:/users/{userId}/accounts/{accountId}/associations
     * @secure
     */
    deleteAnAssociationBetweenUserAndAccount: (
      accountId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/associations`,
        method: "DELETE",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers11
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/associations
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers11: (
      accountId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/associations`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve a list of containers for the given accountId.
     *
     * @name RetrieveAListOfContainersForTheGivenAccountId
     * @request GET:/users/{userId}/accounts/{accountId}/fbs/containers
     * @secure
     */
    retrieveAListOfContainersForTheGivenAccountId: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<FBSContainerListResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers12
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/containers
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers12: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve container data.
     *
     * @name RetrieveContainerData
     * @request GET:/users/{userId}/accounts/{accountId}/fbs/containers/{contractId}
     * @secure
     */
    retrieveContainerData: (
      contractId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<FBSContainerEntityResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/${contractId}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers13
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/containers/{contractId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers13: (
      contractId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/${contractId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Display cockpit data for the given container
     *
     * @name DisplayCockpitDataForTheGivenContainer
     * @request GET:/users/{userId}/accounts/{accountId}/fbs/containers/{contractId}/cockpit
     * @secure
     */
    displayCockpitDataForTheGivenContainer: (
      userId: string,
      accountId: string,
      contractId: string,
      params: RequestParams = {},
    ) =>
      this.request<FBSCockpitResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/${contractId}/cockpit`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers14
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/containers/{contractId}/cockpit
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers14: (
      userId: string,
      accountId: string,
      contractId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/${contractId}/cockpit`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve available deduction for the given container
     *
     * @name RetrieveAvailableDeductionForTheGivenContainer
     * @request GET:/users/{userId}/accounts/{accountId}/fbs/containers/{contractId}/deductions
     * @secure
     */
    retrieveAvailableDeductionForTheGivenContainer: (
      userId: string,
      accountId: string,
      contractId: string,
      params: RequestParams = {},
    ) =>
      this.request<FBSDeductionAvailableResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/${contractId}/deductions`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Apply a deduction for the given container
     *
     * @name ApplyADeductionForTheGivenContainer
     * @request POST:/users/{userId}/accounts/{accountId}/fbs/containers/{contractId}/deductions
     * @secure
     */
    applyADeductionForTheGivenContainer: (
      userId: string,
      accountId: string,
      contractId: string,
      generated: FBSDeductionRequest,
      params: RequestParams = {},
    ) =>
      this.request<ActionPostedWithoutNewRecord, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/${contractId}/deductions`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers15
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/containers/{contractId}/deductions
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers15: (
      userId: string,
      accountId: string,
      contractId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/${contractId}/deductions`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Assesst the filling state of a list of containers
     *
     * @name AssesstTheFillingStateOfAListOfContainers
     * @request GET:/users/{userId}/accounts/{accountId}/fbs/containers/assessments
     * @secure
     */
    assesstTheFillingStateOfAListOfContainers: (
      userId: string,
      accountId: string,
      query: {
        /** Comma Separated List of containers defined by their contract id */
        contractIds: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FBSContainerAssessmentResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/assessments`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers16
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/containers/assessments
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers16: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/assessments`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description List orders
     *
     * @name ListOrders
     * @request GET:/users/{userId}/accounts/{accountId}/fbs/containers/orders
     * @secure
     */
    listOrders: (
      userId: string,
      accountId: string,
      query: {
        /** @format date */
        endDate: string;
        offset?: number;
        status?: "OPEN" | "CLOSED";
        limit?: number;
        /** @format date */
        startDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FBSOrderListResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/orders`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Request the refilling of a list of containers
     *
     * @name RequestTheRefillingOfAListOfContainers
     * @request POST:/users/{userId}/accounts/{accountId}/fbs/containers/orders
     * @secure
     */
    requestTheRefillingOfAListOfContainers: (
      userId: string,
      accountId: string,
      generated: FBSOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<FBSOrderResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/orders`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers17
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/containers/orders
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers17: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/orders`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Simulates an order for pricing purposes
     *
     * @name SimulatesAnOrderForPricingPurposes
     * @request POST:/users/{userId}/accounts/{accountId}/fbs/containers/orders/simulations
     * @secure
     */
    simulatesAnOrderForPricingPurposes: (
      userId: string,
      accountId: string,
      generated: FBSSimulateOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<FBSSimulateOrderResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/orders/simulations`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers18
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/containers/orders/simulations
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers18: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/containers/orders/simulations`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Post a new meter reading for a given meter number
     *
     * @name PostANewMeterReadingForAGivenMeterNumber
     * @request POST:/users/{userId}/accounts/{accountId}/fbs/meter-readings
     * @secure
     */
    postANewMeterReadingForAGivenMeterNumber: (
      userId: string,
      accountId: string,
      generated: FBSMBaseMeterReadingRequest,
      params: RequestParams = {},
    ) =>
      this.request<RecordCreated, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/meter-readings`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers19
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/meter-readings
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers19: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/meter-readings`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Post a new meter reading for a given meter number with up to 2 photos
     *
     * @name PostANewMeterReadingForAGivenMeterNumberWithUpTo2Photos
     * @request POST:/users/{userId}/accounts/{accountId}/fbs/meter-readings/attachments
     */
    postANewMeterReadingForAGivenMeterNumberWithUpTo2Photos: (
      userId: string,
      accountId: string,
      generated: {
        formData: FBSMBaseMeterReadingRequest;
        /** @format binary */
        file1: File;
        /** @format binary */
        file2?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<RecordCreated, any>({
        path: `/users/${userId}/accounts/${accountId}/fbs/meter-readings/attachments`,
        method: "POST",
        body: generated,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new opportunity for Bio contracts
     *
     * @name CreatesANewOpportunityForBioContracts
     * @request POST:/users/{userId}/accounts/{accountId}/fbs/bio/opportunities
     * @secure
     */
    createsANewOpportunityForBioContracts: (
      userId: string,
      accountId: string,
      generated: OpportunityRequest,
      params: RequestParams = {},
    ) =>
      this.request<ActionPostedWithoutNewRecord, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/bio/opportunities`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Bio contract opportunities for a given customer
     *
     * @name RetrieveBioContractOpportunitiesForAGivenCustomer
     * @request GET:/users/{userId}/accounts/{accountId}/fbs/bio/opportunities
     * @secure
     */
    retrieveBioContractOpportunitiesForAGivenCustomer: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<OpportunitiesResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/bio/opportunities`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers20
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/bio/opportunities
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers20: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/bio/opportunities`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve a list of invoices for the given account
     *
     * @name RetrieveAListOfInvoicesForTheGivenAccount
     * @request GET:/users/{userId}/accounts/{accountId}/fbs/invoices
     * @secure
     */
    retrieveAListOfInvoicesForTheGivenAccount: (
      userId: string,
      accountId: string,
      query: {
        /** @format date */
        fromDate: string;
        /** @format date */
        toDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FBSInvoicesResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/invoices`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers21
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/fbs/invoices
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers21: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/fbs/invoices`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Add a new shipping address
     *
     * @name AddANewShippingAddress
     * @request POST:/users/{userId}/accounts/{accountId}/gas/addresses/shipping
     * @secure
     */
    addANewShippingAddress: (
      userId: string,
      accountId: string,
      generated: GASAddShippingAddressRequest,
      params: RequestParams = {},
    ) =>
      this.request<GASAddShippingAddressResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/gas/addresses/shipping`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers22
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/gas/addresses/shipping
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers22: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/gas/addresses/shipping`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete a shipping address
     *
     * @name DeleteAShippingAddress
     * @request DELETE:/users/{userId}/accounts/{accountId}/gas/addresses/shipping/{addressId}
     * @secure
     */
    deleteAShippingAddress: (
      addressId: string,
      userId: string,
      accountId: string,
      query: {
        salesOrganizationId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/gas/addresses/shipping/${addressId}`,
        method: "DELETE",
        query: query,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers23
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/gas/addresses/shipping/{addressId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers23: (
      addressId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/gas/addresses/shipping/${addressId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description List GAS orders
     *
     * @name ListGasOrders
     * @request GET:/users/{userId}/accounts/{accountId}/gas/orders
     * @secure
     */
    listGasOrders: (
      userId: string,
      accountId: string,
      query: {
        /** @format date */
        endDate: string;
        /** comma separated list of codes to filter the result */
        statusCodes?: string;
        offset?: number;
        salesOrganizationId: string;
        limit?: number;
        /** @format date */
        startDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GASOrderHistoryResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/gas/orders`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers24
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/gas/orders
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers24: (
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/gas/orders`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve Gas order details
     *
     * @name RetrieveGasOrderDetails
     * @request GET:/users/{userId}/accounts/{accountId}/gas/orders/{contractId}
     * @secure
     */
    retrieveGasOrderDetails: (
      contractId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<GASOrderDetailsResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/gas/orders/${contractId}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers25
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/gas/orders/{contractId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers25: (
      contractId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/gas/orders/${contractId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Search assets for the given category
     *
     * @name SearchAssetsForTheGivenCategory0
     * @request GET:/users/{userId}/accounts/{accountId}/assets/{category}
     * @secure
     */
    searchAssetsForTheGivenCategory0: (
      userId: string,
      accountId: string,
      category: "hub-all",
      query?: {
        /** @format date */
        startDate?: string;
        /** @format date */
        endDate?: string;
        /** @uniqueItems true */
        service?: ServiceListType[];
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/assets/${category}`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers26
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/assets/{category}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers26: (
      userId: string,
      accountId: string,
      category: "hub-all",
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/assets/${category}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Translate documents to signed urls
     *
     * @name TranslateDocumentsToSignedUrls
     * @request POST:/users/{userId}/accounts/{accountId}/assets/{category}/signed-urls/download
     * @secure
     */
    translateDocumentsToSignedUrls: (
      userId: string,
      accountId: string,
      category:
        | "invoices-fbs"
        | "invoices-gas"
        | "delivery-notes"
        | "delivery-receipts",
      generated: SearchAssetsRequestType,
      params: RequestParams = {},
    ) =>
      this.request<DownloadResponseSignedUrlsType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/assets/${category}/signed-urls/download`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers27
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/assets/{category}/signed-urls/download
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers27: (
      userId: string,
      accountId: string,
      category:
        | "invoices-fbs"
        | "invoices-gas"
        | "delivery-notes"
        | "delivery-receipts",
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/assets/${category}/signed-urls/download`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description generate upload signed urls
     *
     * @name GenerateUploadSignedUrls
     * @request POST:/users/{userId}/accounts/{accountId}/assets/{category}/signed-urls/upload
     * @secure
     */
    generateUploadSignedUrls: (
      userId: string,
      accountId: string,
      category: "meter-readings",
      generated: UploadRequestSignedURLsType,
      params: RequestParams = {},
    ) =>
      this.request<UploadResponseSignedUrlsType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/assets/${category}/signed-urls/upload`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers28
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/assets/{category}/signed-urls/upload
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers28: (
      userId: string,
      accountId: string,
      category: "meter-readings",
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/assets/${category}/signed-urls/upload`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Search assets for the given category
     *
     * @name DownloadADocumentUsingIts
     * @request GET:/users/{userId}/accounts/{accountId}/assets/{category}/{documentId}/signed-urls/download
     * @secure
     */
    downloadADocumentUsingIts: (
      userId: string,
      accountId: string,
      category: "hub-all",
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DownloadResponseSignedUrlsType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/assets/${category}/${documentId}/signed-urls/download`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers29
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/assets/{category}/{documentId}/signed-urls/download
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers29: (
      userId: string,
      accountId: string,
      category: "hub-all",
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/assets/${category}/${documentId}/signed-urls/download`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve active carts for given user, account and webstore combo
     *
     * @name RetrieveActiveCartsForGivenUserAccountAndWebstoreCombo
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts
     * @secure
     */
    retrieveActiveCartsForGivenUserAccountAndWebstoreCombo: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<SearchCartsResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new cart
     *
     * @name CreateANewCart
     * @request POST:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts
     * @secure
     */
    createANewCart: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      generated: CreateCartRequestType,
      params: RequestParams = {},
    ) =>
      this.request<CreateCartResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers30
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers30: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve a cart
     *
     * @name RetrieveACart
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}
     * @secure
     */
    retrieveACart: (
      cartId: string,
      webstoreExternalId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveCartResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a cart status
     *
     * @name UpdateACartStatus
     * @request PATCH:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}
     * @secure
     */
    updateACartStatus: (
      cartId: string,
      webstoreExternalId: string,
      userId: string,
      accountId: string,
      generated: UpdateCartRequestType,
      params: RequestParams = {},
    ) =>
      this.request<RecordUpdated, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}`,
        method: "PATCH",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers31
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers31: (
      cartId: string,
      webstoreExternalId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve cart items
     *
     * @name RetrieveCartItems
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/items
     * @secure
     */
    retrieveCartItems: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      cartId: string,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveCartItemsResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/items`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Add an Item to the cart
     *
     * @name AddAnItemToTheCart
     * @request POST:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/items
     * @secure
     */
    addAnItemToTheCart: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      cartId: string,
      generated: AddCartItemRequestType,
      params: RequestParams = {},
    ) =>
      this.request<UpsertCartItemResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/items`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers32
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/items
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers32: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      cartId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/items`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update an existing item of cart
     *
     * @name UpdateAnExistingItemOfCart
     * @request PUT:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/items/{cartItemId}
     * @secure
     */
    updateAnExistingItemOfCart: (
      cartItemId: string,
      webstoreExternalId: string,
      userId: string,
      accountId: string,
      cartId: string,
      generated: UpdateCartItemRequestType,
      params: RequestParams = {},
    ) =>
      this.request<UpsertCartItemResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/items/${cartItemId}`,
        method: "PUT",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a cart item from the cart
     *
     * @name RemoveACartItemFromTheCart
     * @request DELETE:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/items/{cartItemId}
     * @secure
     */
    removeACartItemFromTheCart: (
      cartItemId: string,
      webstoreExternalId: string,
      userId: string,
      accountId: string,
      cartId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/items/${cartItemId}`,
        method: "DELETE",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers33
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/items/{cartItemId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers33: (
      cartItemId: string,
      webstoreExternalId: string,
      userId: string,
      accountId: string,
      cartId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/items/${cartItemId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Place an order from an active cart with items
     *
     * @name PlaceAnOrderFromAnActiveCartWithItems0
     * @request POST:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/checkout
     * @secure
     */
    placeAnOrderFromAnActiveCartWithItems0: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      cartId: string,
      generated: GASOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<GASOrderResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/checkout`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers34
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/checkout
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers34: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      cartId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/checkout`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Place an order from an active cart with items
     *
     * @name PlaceAnOrderFromAnActiveCartWithItems1
     * @request POST:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/checkout/simulation
     * @secure
     */
    placeAnOrderFromAnActiveCartWithItems1: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      cartId: string,
      generated: GASCheckoutSimulationRequest,
      params: RequestParams = {},
    ) =>
      this.request<GASCheckoutSimulationResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/checkout/simulation`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers35
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/carts/{cartId}/checkout/simulation
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers35: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      cartId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/carts/${cartId}/checkout/simulation`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve active wishlists for given user, account and webstore combo
     *
     * @name RetrieveActiveWishlistsForGivenUserAccountAndWebstoreCombo
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists
     * @secure
     */
    retrieveActiveWishlistsForGivenUserAccountAndWebstoreCombo: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<SearchWishlistsResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new wishlist
     *
     * @name CreateANewWishlist
     * @request POST:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists
     * @secure
     */
    createANewWishlist: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      generated: CreateWishlistRequestType,
      params: RequestParams = {},
    ) =>
      this.request<CreateWishlistResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers36
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers36: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve a wishlist
     *
     * @name RetrieveAWishlist
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists/{wishlistId}
     * @secure
     */
    retrieveAWishlist: (
      wishlistId: string,
      webstoreExternalId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveWishlistResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists/${wishlistId}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers37
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists/{wishlistId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers37: (
      wishlistId: string,
      webstoreExternalId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists/${wishlistId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve wishlist items
     *
     * @name RetrieveWishlistItems
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists/{wishlistId}/items
     * @secure
     */
    retrieveWishlistItems: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      wishlistId: string,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveWishlistItemsResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists/${wishlistId}/items`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Add an Item to the wishlist
     *
     * @name AddAnItemToTheWishlist
     * @request POST:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists/{wishlistId}/items
     * @secure
     */
    addAnItemToTheWishlist: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      wishlistId: string,
      generated: AddWishlistItemRequestType,
      params: RequestParams = {},
    ) =>
      this.request<UpsertWishlistItemResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists/${wishlistId}/items`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers38
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists/{wishlistId}/items
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers38: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      wishlistId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists/${wishlistId}/items`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update a wishlist item from the wishlist
     *
     * @name UpdateAWishlistItemFromTheWishlist
     * @request PATCH:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists/{wishlistId}/items/{wishlistItemId}
     * @secure
     */
    updateAWishlistItemFromTheWishlist: (
      wishlistItemId: string,
      webstoreExternalId: string,
      wishlistId: string,
      userId: string,
      accountId: string,
      generated: UpdateWishlistItemRequestType,
      params: RequestParams = {},
    ) =>
      this.request<UpsertWishlistItemResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists/${wishlistId}/items/${wishlistItemId}`,
        method: "PATCH",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a wishlist item from the wishlist
     *
     * @name RemoveAWishlistItemFromTheWishlist
     * @request DELETE:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists/{wishlistId}/items/{wishlistItemId}
     * @secure
     */
    removeAWishlistItemFromTheWishlist: (
      wishlistItemId: string,
      webstoreExternalId: string,
      wishlistId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists/${wishlistId}/items/${wishlistItemId}`,
        method: "DELETE",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers39
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/wishlists/{wishlistId}/items/{wishlistItemId}
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers39: (
      wishlistItemId: string,
      webstoreExternalId: string,
      wishlistId: string,
      userId: string,
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/wishlists/${wishlistId}/items/${wishlistItemId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve products for given categories
     *
     * @name RetrieveProductsForGivenCategories
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/products/pallets
     * @secure
     */
    retrieveProductsForGivenCategories: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      query: {
        categories: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MPCProductResponseType, Type2>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/products/pallets`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve product recommendations
     *
     * @name RetrieveProductRecommendations
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/products/recommendations
     * @secure
     */
    retrieveProductRecommendations: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      query?: {
        language?: string;
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductRecommendationsResponseType, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/products/recommendations`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers40
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/products/recommendations
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers40: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/products/recommendations`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve product prices
     *
     * @name RetrieveProductPrices
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/products/prices
     * @secure
     */
    retrieveProductPrices: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      query: {
        /** Comma separated list of product codes to price */
        externalIds: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductPricesResponsetype, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/products/prices`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers41
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/products/prices
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers41: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/products/prices`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve rentals equipments
     *
     * @name RetrieveRentalsEquipments
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/rentals
     * @secure
     */
    retrieveRentalsEquipments: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<RentalsSearchResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/rentals`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers42
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/rentals
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers42: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/rentals`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve quotas and refrigerants
     *
     * @name RetrieveQuotasAndRefrigerants
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/quotas
     * @secure
     */
    retrieveQuotasAndRefrigerants: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      query: {
        /** @format date */
        fromDate: string;
        /** @format date */
        toDate: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QuotasResponse, Type | void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/quotas`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers43
     * @request OPTIONS:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/quotas
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers43: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/quotas`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieve pickup locations for store
     *
     * @name RetrievePickupLocationsForStore
     * @request GET:/users/{userId}/accounts/{accountId}/webstores/{webstoreExternalId}/addresses/pickups
     * @secure
     */
    retrievePickupLocationsForStore: (
      userId: string,
      accountId: string,
      webstoreExternalId: string,
      query: {
        latitude: number;
        longitud: number;
        /**
         * distance expressed in kilometers.
         * @min 1
         * @max 1000000000
         */
        distance: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PickupsResponse, Type2>({
        path: `/users/${userId}/accounts/${accountId}/webstores/${webstoreExternalId}/addresses/pickups`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new associations
     *
     * @name CreateANewAssociations
     * @request POST:/users/{userId}/accounts/associations
     * @secure
     */
    createANewAssociations: (
      userId: string,
      generated: DocumentValidationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<DocumentValidationsResponse, Type | void>({
        path: `/users/${userId}/accounts/associations`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUsers44
     * @request OPTIONS:/users/{userId}/accounts/associations
     * @originalName optionsUsers
     * @duplicate
     * @secure
     */
    optionsUsers44: (userId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/users/${userId}/accounts/associations`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  catalogue = {
    /**
     * @description Search products from a store
     *
     * @name SearchProductsFromAStore
     * @request GET:/catalogue/products
     * @secure
     */
    searchProductsFromAStore: (
      query: {
        /** comma separated list of produts represented by their externalId */
        externalIds: string;
        webstoreExternalId: string;
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSearchResponseType, Type | void>({
        path: `/catalogue/products`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue
     * @request OPTIONS:/catalogue/products
     * @secure
     */
    optionsCatalogue: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/catalogue/products`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get a product
     *
     * @name GetAProduct
     * @request GET:/catalogue/products/{externalId}
     * @secure
     */
    getAProduct: (
      externalId: string,
      query?: {
        language?: string;
        webstoreExternalId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CatalogueProductDetailsType, Type | void>({
        path: `/catalogue/products/${externalId}`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue2
     * @request OPTIONS:/catalogue/products/{externalId}
     * @originalName optionsCatalogue
     * @duplicate
     * @secure
     */
    optionsCatalogue2: (externalId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/catalogue/products/${externalId}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Search assets for the given category
     *
     * @name SearchAssetsForTheGivenCategory1
     * @request GET:/catalogue/products/{externalId}/assets/{category}
     * @secure
     */
    searchAssetsForTheGivenCategory1: (
      externalId: string,
      category: "product-data" | "safety-sheets" | "further-product-documents",
      query?: {
        webstoreExternalId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResponseType, Type | void>({
        path: `/catalogue/products/${externalId}/assets/${category}`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue3
     * @request OPTIONS:/catalogue/products/{externalId}/assets/{category}
     * @originalName optionsCatalogue
     * @duplicate
     * @secure
     */
    optionsCatalogue3: (
      externalId: string,
      category: "product-data" | "safety-sheets" | "further-product-documents",
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/catalogue/products/${externalId}/assets/${category}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Download assets via signed-urls
     *
     * @name DownloadAssetsViaSignedUrls
     * @request POST:/catalogue/products/{externalId}/assets/{category}/signed-urls/download
     * @secure
     */
    downloadAssetsViaSignedUrls: (
      externalId: string,
      category: "product-data" | "safety-sheets" | "further-product-documents",
      generated: DownloadRequestSignedURLsType,
      params: RequestParams = {},
    ) =>
      this.request<DownloadResponseSignedUrlsType, Type | void>({
        path: `/catalogue/products/${externalId}/assets/${category}/signed-urls/download`,
        method: "POST",
        body: generated,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue4
     * @request OPTIONS:/catalogue/products/{externalId}/assets/{category}/signed-urls/download
     * @originalName optionsCatalogue
     * @duplicate
     * @secure
     */
    optionsCatalogue4: (
      externalId: string,
      category: "product-data" | "safety-sheets" | "further-product-documents",
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/catalogue/products/${externalId}/assets/${category}/signed-urls/download`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  ui = {
    /**
     * @description Retrieve a collection of picklists
     *
     * @name Picklists
     * @request GET:/ui/metadata/picklists
     * @secure
     */
    picklists: (
      query: {
        object: "Case" | "ProductComponent";
        recordType: "Support" | "Default";
      },
      params: RequestParams = {},
    ) =>
      this.request<PickListResponse, Type | void>({
        path: `/ui/metadata/picklists`,
        method: "GET",
        query: query,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsUi
     * @request OPTIONS:/ui/metadata/picklists
     * @secure
     */
    optionsUi: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/ui/metadata/picklists`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  webstores = {
    /**
     * @description Retrieve the product code associated to the barcode and webstore
     *
     * @name RetrieveTheProductCodeAssociatedToTheBarcodeAndWebstore
     * @request GET:/webstores/{webstoreExternalId}/barcodes/{barcode}
     * @secure
     */
    retrieveTheProductCodeAssociatedToTheBarcodeAndWebstore: (
      webstoreExternalId: string,
      barcode: string,
      params: RequestParams = {},
    ) =>
      this.request<BarcodeProductType, Type | void>({
        path: `/webstores/${webstoreExternalId}/barcodes/${barcode}`,
        method: "GET",
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsWebstores
     * @request OPTIONS:/webstores/{webstoreExternalId}/barcodes/{barcode}
     * @secure
     */
    optionsWebstores: (
      webstoreExternalId: string,
      barcode: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/webstores/${webstoreExternalId}/barcodes/${barcode}`,
        method: "OPTIONS",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
